/**
 * Модификаторы, которые несёт протокол прокси (DF82, владелец 29.10): Keep-Alive и gzip — у HTTP, UDP — у SOCKS5.
 * Карточка «Информация о прокси» показывает только их; группа «UDP» в фильтрах прокси считает только SOCKS5 (иначе все
 * HTTP легли бы в «Выкл»). Формы правки — то же правило, у массовой ещё «не изменять» (pages/Proxies/bulkEdit.js, D29).
 */
export const proxyModifiersForType = (proxyType) => {
  const socks5 = String(proxyType ?? '').trim().toLowerCase() === 'socks5';
  return { keepAlive: !socks5, gzip: !socks5, udp: socks5 };
};

/**
 * Выбранные чипы группы модификатора («Вкл»/«Выкл») — значения серверного фильтра. Сервер берёт только прокси протокола
 * модификатора (backend/proxy_modifiers.py); оба значения — все прокси протокола, поэтому уходят оба.
 */
export const modifierFilterValues = (chips) => (Array.isArray(chips) ? chips : [])
  .map((val) => (val === true || val === 'Вкл' ? true : val === false || val === 'Выкл' ? false : null))
  .filter((val) => val !== null);
